import { createSelector } from 'reselect';
import find from 'lodash/find';
import filter from 'lodash/filter';
import map from 'lodash/map';
import some from 'lodash/some';
import get from 'lodash/get';
import memoize from 'lodash/memoize';
import ProductConstants from '../common/ProductConstants';

import { initProductOptions, isSelectedOptionsEqual } from './ProductOptionsSelector';
import { selectFeatureFlags } from './ContextSelector';
// import { selectProductOffering } from './fromState';
import {
    selectProductDetailsBySource,
    selectInventoryBySource,
    selectProductOfferingBySource,
} from './PdpNameSpaceSelector';

// Currently Selected Delivery Option Name
const getDeliveryOptionsName = (state) => state.deliveryOptionsName || {};

export const getselectedOptions = memoize((sourceMiniPDP = false) =>
    createSelector(
        [initProductOptions(sourceMiniPDP)],
        (productOptions) => productOptions.optionsSelected
    )
);

export const getCouponPriceDetails = (inventory, productDetails, selectedLot) => {
    let couponPriceDetails = null;
    let inventoryData = null;
    let selectedLotPrice = null;
    let selectedInventoryData = null;
    if (inventory && inventory[0]) {
        const ppId = productDetails.id;
        /* istanbul ignore else */
        if (
            inventory[0].prices &&
            inventory[0].prices[ppId] &&
            inventory[0].prices[ppId].detailedPrice
        ) {
            couponPriceDetails = inventory[0].prices[ppId].detailedPrice;
        }

        if (inventory[0].lotPrice && inventory[0].lotPrice.data) {
            inventoryData = inventory[0].lotPrice.data;
        }

        /* istanbul ignore else */
        if (selectedLot) {
            selectedLotPrice = find(couponPriceDetails, {
                productId: selectedLot.id,
            });

            selectedInventoryData = find(inventoryData, {
                id: selectedLot.id,
            });
        }

        /* istanbul ignore else */
        if (
            selectedLotPrice &&
            selectedInventoryData &&
            !selectedInventoryData.manufacturerAdvertised
        ) {
            couponPriceDetails = selectedLotPrice;
        }
    } else {
        couponPriceDetails = null;
    }
    return couponPriceDetails;
};

/* istanbul ignore next */
const getEligibilityCouponInfo = (couponInfoData = {}) => {
    const couponInfo = [...couponInfoData.eligibleCouponInfo];
    const eligibilityCouponInfo = {
        ...couponInfoData,
        couponInfo,
    };
    return get(eligibilityCouponInfo, 'couponInfo.length') ? eligibilityCouponInfo : null;
};

/* istanbul ignore next */
const getCouponPriceDetailsFromRTP = (inventory = [], selectedLot = {}) => {
    if (inventory.length) {
        const selectedLotID = selectedLot.id;
        const lotData = get(inventory[0], 'lotPrice.data', []);
        const getCouponInfo = lotData.find((lot) => lot.id === selectedLotID);
        if (getCouponInfo && getCouponInfo.eligibleCouponInfo) {
            return getEligibilityCouponInfo(getCouponInfo);
        }
        return get(getCouponInfo, 'couponInfo.length') ? getCouponInfo : null;
    }
    return null;
};

const productFinalPriceAfterCoupon = memoize((sourceMiniPDP) =>
    createSelector(
        [
            selectInventoryBySource(sourceMiniPDP),
            selectProductDetailsBySource(sourceMiniPDP),
            getselectedOptions(sourceMiniPDP),
            selectFeatureFlags,
            selectProductOfferingBySource(sourceMiniPDP),
            getDeliveryOptionsName,
        ],
        (
            inventory,
            productDetails,
            selectedOptions,
            featureFlags,
            productOffering = {},
            deliveryOption
        ) => {
            const bopisIncentiveEnabled =
                featureFlags.enableBopisIncentive &&
                deliveryOption.selectedOption === ProductConstants.BOPIS_SELECTED_OPTION;
            if (Object.keys(productOffering).length) {
                // When bopis incentive enabled, fetch price from bopis object
                if (bopisIncentiveEnabled) {
                    if (
                        productOffering.pricing &&
                        productOffering.pricing.bopis &&
                        productOffering.pricing.bopis.eligibleCouponInfo
                    ) {
                        return getEligibilityCouponInfo(productOffering.pricing.bopis);
                    }
                    /* istanbul ignore else */
                    if (productOffering.pricing && productOffering.pricing.bopis) {
                        return productOffering.pricing.bopis;
                    }
                } else if (productOffering.pricing && productOffering.pricing.eligibleCouponInfo) {
                    return getEligibilityCouponInfo(productOffering.pricing);
                }
                return productOffering.pricing;
            }
            let selectedLot = filter(productDetails.lots, { isDefault: true });
            /* istanbul ignore next */
            if (selectedOptions.length && selectedLot) {
                const filterValues = map(
                    selectedOptions,
                    ({ option: value, dimensionName: name }) => ({ name, value })
                );
                selectedLot = filter(productDetails.lots, ({ items }) =>
                    some(items, isSelectedOptionsEqual(filterValues))
                );
            }
            return getCouponPriceDetailsFromRTP(inventory, selectedLot[0]);
        }
    )
);

export default productFinalPriceAfterCoupon;
